<template>

  <t-page>

    <t-page-form card
                 :title="command === 'insert' ? currentPage.pageTitle : currentPage.pageTitle + ' - Nº ' + form.productionBulkActionNumber"
                 :submit-text-not-default="command !== 'delete'"
                 :submit-text="command === 'delete' ? currentPage.singularTitle : ''"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default>

        <div v-if="pageFormIsLoaded && form.statusBulkAction === StatusBulkActionType.type.PENDING">

          <form-wizard title="" @on-change="onWizardTabChange" :start-index="command === 'insert' ? 0 : 1" subtitle="">

            <tab-content title="Dados">

              <div class="border-top pt-3">
                <b-card-title>Relação de Ordens de Fabricação</b-card-title>

                <t-input v-model="form.processFlowId"
                         :fixed="command !== 'insert'"
                         :options="processFlowOptions"
                         select
                         placeholder="Não"
                         label="Deseja restringir a somente um fluxo de processos?"/>

                <div v-if="command === 'insert'" class="mt-3 pt-3 border-top">

                  <b-card-sub-title>Informe as ordens que deseja realizar a ação em lote, sendo uma por linha
                  </b-card-sub-title>

                  <t-input v-model="form.content" small="" required class-input="h-min-200" label="Ordens de Fabricação"
                           max-length="10000" textarea/>

                </div>

                <div v-else class="p-5">

                  <t-msg info>Dados enviados com sucesso! Verifique a guia Análise para detalhar as informações</t-msg>

                </div>


              </div>


            </tab-content>

            <tab-content title="Análise">

              <div class="border-top pt-3">

                <b-card-title>Verifique as ações desejadas</b-card-title>

                <ProductionOrderBulkActionItem placeholder="Cód. da Ordem de Fabricação"
                                               v-if="pageFormIsLoaded && !refreshItems && command !== 'insert'"
                                               :foreign-key="form[fieldKey]"
                                               :foreign-number="form[fieldNumber]"/>

              </div>
            </tab-content>
            <tab-content title="Resumo">

              <div class="border-top pt-3">

                <b-card-title>Resumo</b-card-title>

                <b-row v-if="pageFormIsLoaded && command !== 'insert'">
                  <t-input cols="6" v-model="form.logControl.createdUser" label="Usuário" fixed/>
                  <t-input cols="6" v-model="form.logControl.createdDate" label="Data Cadastro" fixed datetime/>
                </b-row>

                <div class="no-gutters row">
                  <div class="col-sm-6 col-md-4 col-xl-4">
                    <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
                      <div class="icon-wrapper rounded-circle">
                        <div class="icon-wrapper-bg opacity-10 bg-warning d-flex align-items-center">
                          <i class="pe-7s-info text-white"> </i>
                        </div>


                      </div>
                      <div class="widget-chart-content">
                        <div class="widget-subheading">Qtd. Total</div>
                        <div class="widget-numbers">{{ bulkActionTotal.qtyTotal }}</div>
                      </div>
                    </div>
                    <div class="divider m-0 d-md-none d-sm-block"></div>
                  </div>
                  <div class="col-sm-6 col-md-4 col-xl-4">
                    <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
                      <div class="icon-wrapper rounded-circle">
                        <div class="icon-wrapper-bg opacity-9 bg-danger d-flex align-items-center">
                          <i class="pe-7s-trash text-white"> </i>
                        </div>

                      </div>
                      <div class="widget-chart-content">
                        <div class="widget-subheading">Qtd. Erros</div>
                        <div class="widget-numbers"><span>{{ bulkActionTotal.qtyErrors }}</span></div>
                      </div>
                    </div>
                    <div class="divider m-0 d-md-none d-sm-block"></div>
                  </div>
                  <div class="col-sm-12 col-md-4 col-xl-4">
                    <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
                      <div class="icon-wrapper rounded-circle">
                        <div class="icon-wrapper-bg opacity-9 bg-success d-flex align-items-center">
                          <i class="pe-7s-check text-white"> </i>

                        </div>
                      </div>
                      <div class="widget-chart-content">
                        <div class="widget-subheading">Qtd. Válido</div>
                        <div class="widget-numbers text-success"><span>{{ bulkActionTotal.qtyValidated }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>


            </tab-content>

            <template #footer="props">

              <div class="wizard-footer-left">
                <!--Não permite retornar para a etapa de dados para evitar complexidade de exibir as informações novamente-->
                <t-button outline-primary v-if="props.activeTabIndex > 1" @click.native="props.prevTab()"
                          :style="props.fillButtonStyle">
                  <b-icon-arrow-left class="mr-2"/>
                  {{ t('go-back') }}
                </t-button>
              </div>


              <div class="wizard-footer-right" v-if="command === 'insert'">

                <t-button submit :sending="status === 'sending'" primary text="Enviar Dados em Massa"/>

                <!--              <wizard-button v-else  class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? 'Done' : 'Next'}}</wizard-button>-->
              </div>

              <div class="wizard-footer-right" v-else>


                <t-button v-show="!props.isLastStep" primary @click.native="props.nextTab()"
                          :style="props.fillButtonStyle">{{ t('next') }}
                  <b-icon-arrow-right class="ml-2"/>
                </t-button>

                <t-button v-show="props.isLastStep" submit primary text="Iniciar Processamento"/>

                <!--              <wizard-button v-else  class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? 'Done' : 'Next'}}</wizard-button>-->
              </div>


            </template>

          </form-wizard>


        </div>

        <div v-else>

          <b-card-title>Dados Básicos</b-card-title>

          <b-row v-if="pageFormIsLoaded">
            <t-input cols="4" v-model="form.logControl.createdDate" label="Data Cadastro" fixed datetime/>
            <t-input cols="4" v-model="form.generalStartDate" label="Início do Processamento" fixed datetime/>
            <t-input cols="4" v-model="form.generalFinishDate" label="Término do Processamento" fixed datetime/>
          </b-row>

          <div v-if="form.statusBulkAction === StatusBulkActionType.type.PROCESSING">
            <h6>Em processamento, por favor aguarde</h6>
            <b-progress height="2rem" :value="bulkActionTotal.qtyProcessed" :max="bulkActionTotal.qtyValidated"
                        show-progress animated>
              <b-progress-bar :value="bulkActionTotal.qtyProcessed">{{ bulkActionTotal.qtyProcessed }} /
                {{ bulkActionTotal.qtyValidated }}
              </b-progress-bar>
            </b-progress>
          </div>


        </div>

      </template>

      <template #out-of-form
                v-if="pageFormIsLoaded && (form.statusBulkAction === StatusBulkActionType.type.PROCESSED)">

        <b-card class="mt-3">

          <b-card-title>Itens desta ação em massa</b-card-title>

          <ProductionOrderBulkActionItem placeholder="Cód. da Ordem de Fabricação"
                                         only-view
                                         v-if="pageFormIsLoaded && !refreshItems" :foreign-key="form[fieldKey]"
                                         :foreign-number="form[fieldNumber]"/>

        </b-card>

      </template>


    </t-page-form>


  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import StatusBulkActionType from "@/model/types/resource/StatusBulkActionType";
import ProductionOrderBulkActionItem from "@/views/modules/production/ProductionOrder/ProductionOrderBulkActionItem";
import ProcessFlowService from "@/services/modules/production/ProcessFlow.service";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ProductionOrderBulkActionForm',
  components: {ProductionOrderBulkActionItem},
  data() {
    return {
      StatusBulkActionType,
      path: "production/bulk-action",
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "productionBulkActionId",
      fieldNumber: "productionBulkActionNumber",
      form: {
        productionBulkActionId: 0,
        productionBulkActionNumber: 0,
        processFlowId: 0,
        content: "",
        statusBulkAction: StatusBulkActionType.type.PENDING,
        qtyPending: 0,
        qtyProcess: 0,
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend

      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      refreshItems: false,
      waitSeconds: 1,
      listAnalysis: [],
      processFlowOptions: [],
      bulkActionTotal: {
        qtyValidated: 0,
        qtyErrors: 0,
        qtyPending: 0,
        qtyProcessing: 0,
        qtyProcessed: 0,
        qtyTotal: 0,
      },
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {
      this.pageFormIsLoaded = false
    },
    async mountedContinued() {

      await ProcessFlowService.selectList().then((list) => {
        this.processFlowOptions = list
      }).catch(error => this.responseError(error))

      if (this.form.statusBulkAction === StatusBulkActionType.type.PROCESSING) {

        await this.getTotals()

        setTimeout(async () => {
          await this.processByPart()
        }, this.waitSeconds * 1000)

      }

      this.pageFormIsLoaded = true


    },
    async onSubmit() {

      await this.setSending(
          this.form.productionBulkActionId,
          async (response) => {
            await this.$router.push({path: '/production/bulk-action/' + response[this.fieldNumber]})
            await this.mountedAgain()
          },
          async (response) => {
            await this.$router.push({path: '/production/bulk-action/view/' + response[this.fieldNumber]})
            await this.mountedAgain()
          }, (response) => {
            this.setRedirect('/production/bulk-action/', response[this.fieldKey], this.command, 0, "", true)
          },
      )

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async mountedAgain(refreshLoagin) {

      this.mountedPrepare(refreshLoagin)

      await this.mountedForm(true, false)

      await this.mountedContinued()

    },

    async processByPart() {

      await crudGeneral.get(this.path + "/executeByPart/" + this.form.productionBulkActionId).then(async (response) => {

        this.bulkActionTotal = response.data

        if (this.bulkActionTotal.qtyProcessing === 0) {

          //Execução finalizada
          await this.mountedAgain()

        } else {
          //Chama novamente caso não tenha finalizado
          setTimeout(async () => {
            await this.processByPart()
          }, this.waitSeconds * 2000)
        }

      }).catch(error => this.responseError(error))

    },

    onWizardTabChange(prevIndex, nextIndex) {

      if (nextIndex === 2) {
        this.getTotals()
      }

    },

    async getTotals() {

      await crudGeneral.get(this.path + "/getTotals/" + this.form.productionBulkActionId).then((response) => {
        this.bulkActionTotal = response.data

      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    await this.mountedAgain()

  },

}
</script>
